module.exports = __webpack_public_path__ + "static/img/11.8b901b1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/5/sp/11.png
// module id = Yfez
// module chunks = 0